module.exports = __webpack_public_path__ + "img/reminder-informations.40548458.svg";